import 'react-toastify/dist/ReactToastify.css'
import { type ReactElement } from 'react'
import { Header } from './components/Header'
import { DataExportsData } from './DataExportsData'

export function DataExportsDetail (): ReactElement {
  return (
    <div className="bg-white shadow rounded py-8 mb-32 px-6">
      <Header />
      <DataExportsData />
    </div>
  )
}
